import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';

const MyBlueSwitch = withStyles({
  switchBase: {
    color: '##00C6FF',
    '&$checked': {
      color: '#F87733',
    },
    '&$checked + $track': {
      backgroundColor: '#F87733',
    },
  },
  checked: {},
  track: {},
})(Switch);

export default function BlueSwitch() {
  const [state, setState] = React.useState({
    checkedA: true,
  });

  const handleChange = name => event => {
    setState({ ...state, [name]: event.target.checked });
  };

  return (
    <MyBlueSwitch
      checked={state.checkedA}
      onChange={handleChange('checkedA')}
      value="checkedA"
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/commons/BlueSwitch.js